module.exports = __webpack_public_path__ + "img/ct1.8765cbbe.png";